<template>
  <v-container fluid class="metas-page pa-4 pa-md-6">
    <!-- Filtros -->
    <v-card outlined class="filter-card mb-6">
      <div class="pa-4">
        <v-row align="center">
          <v-col cols="12" sm="auto" class="d-flex align-center pb-0 pb-sm-3">
            <v-icon color="grey" size="22" class="mr-2">mdi-filter-variant</v-icon>
            <span class="subtitle-2 grey--text text--darken-1 font-weight-bold">Filtros</span>
          </v-col>
          <v-col cols="12" sm="4" md="3" class="pb-0 pb-sm-3">
            <v-select
              v-model="select_equipe"
              :items="selects.candidatos.items"
              :disabled="equipe_fixa"
              outlined
              dense
              label="Equipe"
              item-value="idcandidato"
              item-text="nome_completo"
              prepend-inner-icon="mdi-account-group"
              class="styled-select"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="auto" class="pb-0 pb-sm-3">
            <v-btn
              color="primary"
              depressed
              class="btn-novo"
              @click="initialize()"
            >
              <v-icon left small>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <!-- Tabela -->
    <v-card outlined class="table-card">
      <v-data-table
        :headers="headers"
        :items="desserts"
        height="70vh"
        :fixed-header="true"
        :items-per-page="-1"
        :search="search"
        class="modern-table"
      >
        <template v-slot:top>
          <div class="table-header pa-4 pb-2">
            <v-row align="center">
              <v-col cols="12" sm="6" class="d-flex align-center">
                <v-icon color="grey" size="28" class="mr-3">mdi-target</v-icon>
                <div>
                  <div class="title font-weight-bold" style="color: #757575">Cadastro de Metas</div>
                  <div class="caption grey--text">
                    {{ desserts.length }} meta{{ desserts.length !== 1 ? 's' : '' }} cadastrada{{ desserts.length !== 1 ? 's' : '' }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-center justify-sm-end">
                <v-text-field
                  v-model="search"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                  class="styled-input mr-3"
                  style="max-width: 280px"
                ></v-text-field>
                <v-btn
                  color="primary"
                  dark
                  depressed
                  class="btn-novo"
                  @click="openNew()"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Novo
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>

        <!-- Coluna Meta com chip -->
        <template v-slot:item.meta="{ item }">
          <v-chip
            small
            color="#e0f2f1"
            text-color="#216b80"
            class="font-weight-bold"
          >
            {{ item.meta }}
          </v-chip>
        </template>

        <!-- Coluna Ações -->
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn mr-1" v-on="on" @click="editItem(item)">
                <v-icon small color="grey">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar Meta</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn" v-on="on" @click="deleteItem(item)">
                <v-icon small color="red lighten-1">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remover Meta</span>
          </v-tooltip>
        </template>

        <!-- Empty state -->
        <template v-slot:no-data>
          <div class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-target</v-icon>
            <div class="subtitle-1 grey--text text--darken-1 mb-2">Nenhuma meta cadastrada</div>
            <div class="body-2 grey--text">Clique em "Novo" para cadastrar uma meta</div>
          </div>
        </template>

        <!-- No results state -->
        <template v-slot:no-results>
          <div class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-magnify-close</v-icon>
            <div class="subtitle-1 grey--text text--darken-1 mb-2">Nenhum resultado encontrado</div>
            <div class="body-2 grey--text">Tente uma pesquisa diferente</div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog -->
    <v-dialog persistent v-model="dialog" max-width="600px">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header pa-4">
          <v-icon color="grey" class="mr-3">{{ editedIndex === -1 ? 'mdi-target' : 'mdi-pencil' }}</v-icon>
          <span class="title font-weight-bold" style="color: #757575">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.descricao"
                label="Descrição Meta*"
                autofocus
                prepend-inner-icon="mdi-text-short"
                class="styled-input"
                :error-messages="descricaoErrors"
                @input="$v.editedItem.descricao.$touch()"
                @blur="$v.editedItem.descricao.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-1">
              <v-text-field
                outlined
                dense
                v-mask="'######'"
                v-model="editedItem.meta"
                label="Meta*"
                prepend-inner-icon="mdi-numeric"
                class="styled-input"
                :error-messages="metaErrors"
                @input="$v.editedItem.meta.$touch()"
                @blur="$v.editedItem.meta.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="8" class="pb-1">
              <v-select
                v-model="editedItem.idcandidato"
                :items="equipesDialog"
                :disabled="selects.candidatos.ativado"
                outlined
                dense
                label="Equipe*"
                item-value="idcandidato"
                item-text="nome_completo"
                prepend-inner-icon="mdi-account-group"
                class="styled-select"
                :error-messages="equipeErrors"
                @input="$v.editedItem.idcandidato.$touch()"
                @blur="$v.editedItem.idcandidato.$touch()"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn outlined class="btn-action mr-2" @click="close">
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn depressed dark color="primary" class="btn-action" @click="save">
            <v-icon left small>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import AclAPI from "./../../api/acl";

export default {
  name: "Acl",
  data: () => ({
    dialog: false,
    atualizar: 0,
    search: "",
    headers: [
      {
        text: "ID",
        value: "idmeta",
      },
      {
        text: "Descrição Meta",
        align: "left",
        value: "descricao",
      },
      {
        text: "Meta",
        align: "left",
        value: "meta",
      },
      {
        text: "Equipe",
        align: "left",
        value: "idcandidato",
      },
      {
        text: "Candidato",
        align: "left",
        value: "candidato.nome_completo",
      },
      { text: "Ações", value: "action", sortable: false },
    ],
    select_equipe: null,
    equipe_fixa: false,
    desserts: [],
    selects: {
      candidatos: {
        ativado: false,
        items: [],
      },
    },
    editedIndex: -1,
    editedItem: {
      descricao: "",
      meta: "",
      idcandidato: "",
    },
    defaultItem: {
      descricao: "",
      meta: "",
      idcandidato: "",
    },
  }),

  validations: {
    editedItem: {
      descricao: {
        required,
      },
      meta: {
        required,
      },
      idcandidato: {
        required,
      },
    },
  },
  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.descricao.$dirty) return errors;
      !this.$v.editedItem.descricao.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    metaErrors() {
      const errors = [];
      if (!this.$v.editedItem.meta.$dirty) return errors;
      !this.$v.editedItem.meta.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    equipeErrors() {
      const errors = [];
      if (!this.$v.editedItem.idcandidato.$dirty) return errors;
      !this.$v.editedItem.idcandidato.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    // Equipes do dialogo: na criacao oferece "TODAS AS EQUIPES" (sentinela 0, pois o
    // v-select nao distingue null de "nada selecionado"); na edicao, so equipes reais.
    equipesDialog() {
      const reais = this.selects.candidatos.items.filter((c) => c.idcandidato);
      if (this.editedIndex !== -1) return reais;
      return [{ idcandidato: 0, nome_completo: "TODAS AS EQUIPES" }, ...reais];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Meta" : "Editar Meta";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.buscaCandidatos();
    this.initialize();
  },

  methods: {
    buscaCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();
      const equipeLocal = localStorage.getItem("equipe");

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.getCandidatos(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              const candidatos = [
                { idcandidato: null, nome_completo: "TODAS" },
                ...response.data.candidatos,
              ];
              this.selects.candidatos.items = candidatos;

              if (equipeLocal != "null" && equipeLocal != null) {
                this.select_equipe = parseInt(equipeLocal);
                this.equipe_fixa = true;
              }
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    initialize() {
      this.desserts = [];
      const headers = this.Helpers.iniciarRequisicao();

      const equipeLocal = localStorage.getItem("equipe");
      const equipe = (equipeLocal != "null" && equipeLocal != null)
        ? equipeLocal
        : this.select_equipe;

      const params = {
        equipe: equipe,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.getMetas(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.metas;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    openNew() {
      this.setEquipe();
      this.dialog = true;
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover o Meta?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delMeta(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};

                this.initialize();
              }
            })
            .catch((error) => this.tratarErroMeta(error))
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      // Formulario invalido: destaca os campos com erro em vez de ignorar o clique.
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.Helpers.exibirMensagem("Preencha corretamente os campos destacados.", "error", 5000);
        return;
      }

      const headers = this.Helpers.iniciarRequisicao();

      const todasEquipes = this.editedItem.idcandidato === 0;
      const params = todasEquipes
        ? {
            descricao: this.editedItem.descricao,
            meta: this.editedItem.meta,
            todas_equipes: 1,
          }
        : this.editedItem;

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.addMeta(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              if (todasEquipes) {
                const { criadas, ignoradas } = response.data;
                this.Helpers.exibirMensagem(
                  `Meta criada para ${criadas} equipe(s)` +
                    (ignoradas > 0 ? ` (${ignoradas} já tinham essa meta)` : ""),
                  "success",
                  5000
                );
              }
              this.initialize();
            }
          })
          .catch((error) => this.tratarErroMeta(error))
      );

      this.close();
    },
    // 409 (meta em uso) e 404 vêm com a mensagem do back e com o token renovado.
    tratarErroMeta(error) {
      const resp = error && error.response;
      if (resp && (resp.status === 409 || resp.status === 404)) {
        if (resp.data.token) localStorage.setItem("token", resp.data.token);
        this.Helpers.exibirMensagem(resp.data.erro, "error", 6000);
        this.initialize();
      } else {
        alert("Falha na operação!!!");
      }
    },
    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null" && equipe != null) {
        this.editedItem.idcandidato = parseInt(equipe);
        this.selects.candidatos.ativado = true;
      }
    },
  },
};
</script>
<style scoped>
.metas-page {
  animation: fadeInUp 0.4s ease-out;
}

/* --- Cards --- */
.filter-card {
  border-radius: 16px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  background: #fafbfc;
}

.table-card {
  border-radius: 16px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  overflow: hidden;
}

/* --- Selects e Inputs estilizados --- */
.styled-select >>> .v-input__slot,
.styled-input >>> .v-input__slot {
  border-radius: 12px !important;
  min-height: 40px !important;
}

.styled-select >>> fieldset,
.styled-input >>> fieldset {
  border-color: rgba(0, 0, 0, 0.12);
  transition: border-color 0.2s ease;
}

.styled-select >>> .v-input--is-focused fieldset,
.styled-input >>> .v-input--is-focused fieldset {
  border-color: #216b80 !important;
  border-width: 2px;
}

/* --- Botões --- */
.btn-novo {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.btn-novo:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 107, 128, 0.3) !important;
}

.btn-action {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  min-width: 120px !important;
}

.action-icon-btn {
  transition: all 0.2s ease;
}

.action-icon-btn:hover {
  background: rgba(33, 107, 128, 0.08) !important;
  transform: scale(1.1);
}

/* --- Tabela --- */
.table-header {
  background: #fafbfc;
}

.modern-table >>> .v-data-table-header th {
  background: #f5f7fa !important;
  color: #5a6a7e !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  border-bottom: 2px solid rgba(0, 0, 0, 0.08) !important;
}

.modern-table >>> .v-data-table-header th .v-icon {
  color: #5a6a7e !important;
}

.modern-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: rgba(33, 107, 128, 0.04) !important;
}

.modern-table >>> tbody td {
  font-size: 0.85rem !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.modern-table >>> .v-data-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

/* --- Dialog --- */
.dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

/* --- Animação --- */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- Responsivo --- */
@media (max-width: 600px) {
  .metas-page {
    padding: 8px !important;
  }

  .table-card {
    border-radius: 12px !important;
  }

  .btn-novo {
    width: 100%;
  }
}
</style>
